// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login/login';
// 注册
import register from '@/views/login/register';
// 忘记密码
import forget from '@/views/login/forget';
// 单页
import text from '@/views/login/text';
// 首页
import index from '@/views/index';
// 首页
import indexs from '@/views/index/index';
// 考试中心
import exams from '@/views/index/exam';
// 考试中心详情
import examDetails from '@/views/index/examDetails';
// 认证详情
import certificationDetails from '@/views/index/certificationDetails';
// 视频课堂
import classroom from '@/views/index/classroom';
// 视频课堂播放
import playback from '@/views/index/playback';
// 视频课堂详情
import classroomDetails from '@/views/index/classroomDetails';
// 直播
import live from '@/views/index/live';

// 服务与支持
import support from '@/views/index/support';
// 服务与支持详情
import supportDetail from '@/views/index/supportDetail';

// 证书查询
import search from '@/views/index/search';

// 证书预览
import preview from '@/views/index/preview';
// 常见问题
// import courses from '@/views/support/course';
/**
 * 个人中心
 */
// 个人资料
import personal from '@/views/personal/personal';
// 我的报名
import enroll from '@/views/enroll/enroll';
// 我的考试
import exam from '@/views/exam/exam';
// 考试页面
import examPage from '@/views/exam/examPage';
// 查看解析
import analysis from '@/views/exam/analysis';
// 我的证书
import certificate from '@/views/certificate/certificate';
// 我的证书详情
import certificateDetails from '@/views/certificate/certificateDetails';
// 我的证书查看
import certificateText from '@/views/certificate/text';
// 我的课程
import course from '@/views/course/course';
// 我的收藏
import collect from '@/views/collect/collect';
// 我的收藏
import order from '@/views/order/order';
// 我的优惠券
import coupon from '@/views/coupon/coupon';
// 我的发票
import invoice from '@/views/invoice/invoice';
// 账号管理
import manage from '@/views/manage/manage';
// 考试支付
import Orderk from '@/views/pay/Order';
// 课程支付
import Orderz from '@/views/pay/Orderz';
// 直播
import tcplayer from '@/views/index/tcplayer';

// 启用路由
Vue.use(Router);
// 在路由守卫中，例如beforeEach

// 导出路由 
export default new Router({
    routes: [{
        path: '/',
        name: '',
        component:indexs,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login/register',
        name: '注册',
        component: register,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login/forget',
        name: '忘记密码',
        component: forget,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login/text',
        name: '单页',
        component: text,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/index/index',
        name: '首页',
        component: indexs,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/index/exam',
        name: '考试中心',
        component: exams,
        hidden: true,
        meta: {
            requireAuth: false
        }
    },{
        path: '/index/examDetails',
        name: '考试详情',
        component: examDetails,
        hidden: true,
        meta: {
            requireAuth: false
        }
    },{
        path: '/index/certificationDetails',
        name: '认证详情',
        component: certificationDetails,
        hidden: true,
        meta: {
            requireAuth: false
        }
    },{
        path: '/index/classroom',
        name: '视频课堂',
        component: classroom,
        hidden: true,
        meta: {
            requireAuth: false
        }
    },{
        path: '/index/live',
        name: '直播',
        component: live,
        hidden: true,
        meta: {
            requireAuth: false
        }
    },{
        path: '/index/classroomDetails',
        name: '视频课堂详情',
        component: classroomDetails,
        hidden: true,
        meta: {
            requireAuth: false
        }
    },{
        path: '/index/support',
        name: '服务与支持',
        component: support,
        hidden: true,
        meta: {
            requireAuth: false
        }
    },{
        path: '/index/supportDetail',
        name: '详情',
        component: supportDetail,
        hidden: true,
        meta: {
            requireAuth: false
        }
    },
    // {
    //     path: '/support/course',
    //     name: '常见问题',
    //     component: courses,
    //     hidden: true,
    //     meta: {
    //         requireAuth: false
    //     }
    // },
    {
        path: '/index/playback',
        name: '视频课堂详情',
        component: playback,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/index/tcplayer',
        name: '直播',
        component: tcplayer,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/index/search',
        name: '证书查询',
        component: search,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/index/preview',
        name: '证书预览',
        component: preview,
        hidden: true,
        meta: {
            requireAuth: false
        }
    },{
        path: '/exam/examPage',
        name: '我的考试',
        component: examPage,
        hidden: true,
        meta: {
            requireAuth: false
        }
    },{
        path: '/exam/analysis',
        name: '查看解析',
        component: analysis,
        hidden: true,
        meta: {
            requireAuth: false
        }
    },{
        path: '/pay/Order',
        name: '支付',
        component: Orderk,
        hidden: true,
        meta: {
            requireAuth: false,
            newWindow: true
        }
    },{
        path: '/pay/Orderz',
        name: '支付',
        component: Orderz,
        hidden: true,
        meta: {
            requireAuth: false,
            newWindow: true
        }
    },{
        path: '/certificate/text',
        name: '证书详情',
        component: certificateText,
        meta: {
            requireAuth: true
        }
    },{
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [{
            path: '/personal/personal',
            name: '个人资料',
            component: personal,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/enroll/enroll',
            name: '我的报名',
            component: enroll,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/exam/exam',
            name: '我的考试',
            component: exam,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/certificate/certificate',
            name: '我的证书',
            component: certificate,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/certificate/certificateDetails',
            name: '证书详情',
            component: certificateDetails,
            meta: {
                requireAuth: true
            }
        },{
            path: '/course/course',
            name: '我的证书',
            component: course,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/collect/collect',
            name: '我的收藏',
            component: collect,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/order/order',
            name: '我的订单',
            component: order,
            meta: {
                requireAuth: true
            }
        },{
            path: '/coupon/coupon',
            name: '我的优惠券',
            component: coupon,
            meta: {
                requireAuth: true
            }
        },{
            path: '/invoice/invoice',
            name: '我的发票',
            component: invoice,
            meta: {
                requireAuth: true
            }
        },{
            path: '/manage/manage',
            name: '账号管理',
            component: manage,
            meta: {
                requireAuth: true
            }
        }]
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js